import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import {
  PageNotFound,
  PageNotFoundProps,
} from '@oncore/ui/ErrorPages';

import { links } from 'src/components/chrome';
import { getAppStateSelector } from 'src/store/selectors';
import LegacyNotFoundErrorNotice from 'src/components/notice/LegacyNotFoundErrorNotice';

type NotFoundErrorNoticeProps = {
  children?: never;
} & Pick<PageNotFoundProps, 'title' | 'message' | 'className'>;

const NotFoundErrorNotice = (props: NotFoundErrorNoticeProps) => {
  const {
    title,
    message,
    className,
  } = props;
  const navigate = useNavigate();
  const { isUntitledUI } = useSelector(getAppStateSelector());


  const handleGoToLogin = () => {
    navigate(links.logout);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  if (isUntitledUI) {
    return (
      <PageNotFound
        title={title}
        message={message}
        className={className}
        onGoBackClick={handleGoBack}
        onGotoLoginClick={handleGoToLogin}
      />
    );
  }

  return (
    <LegacyNotFoundErrorNotice/>
  );
};

export default NotFoundErrorNotice;
